import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Dashboard from "./components/Dashboard";
import Users from "./components/User";
import Reports from "./components/Reports";
import Login from "./pages/Login";
import Odhwallet from "./components/Payment/Odhwallet";
import Odhmoney from "./components/Wallet/Odhmoney";
import Returnwallet from "./components/Wallet/Returnwallet";
import Withdrawal from "./components/Wallet/Withdrawl";
import Offlinerequest from "./components/Wallet/Offlinerequest";
import Invoices from "./components/Invoices/Recharge";
import Recharge from "./components/Invoices/Recharge";
import Addodh from "./components/Invoices/Addodh";
import Addwallet from "./components/Invoices/Addwallet";
import Createcategory from "./components/Product/Createcategory";
import Addbanner from "./components/Product/Addbanner";
import Addprodtemp from "./components/Product/Addprodtemp";
import Addsize from "./components/Product/Addsize";
import Createbrand from "./components/Product/Createbrand";
import Createdesub from "./components/Product/Createdesub";
import Createproduct from "./components/Product/Createproduct";
import Createsub from "./components/Product/Createsub";
import Createunit from "./components/Product/Createunit";
import Kycapproval from "./components/Approval/Kycapproval";
import Activatemembertxn from "./components/Reports/Activatemembertxn";
import Balancesheet from "./components/Reports/Balancesheet";
import Beneficiary from "./components/Reports/Beneficiary";
import Customerlist from "./components/Reports/Customerlist";
import Failrechargehistory from "./components/Reports/Failrechargehistory";
import Hotelbooking from "./components/Reports/Hotelbooking";
import Interestwallet from "./components/Reports/Interestwallet";
import Investment from "./components/Reports/Investment";
import Membercredit from "./components/Reports/Membercredit";
import Memberwiseincome from "./components/Reports/Memberwiseincome";
import Odhpaymoneymember from "./components/Reports/Odhpaymoneymember";
import Orderproduct from "./components/Reports/Orderproduct";
import Rechargehistory from "./components/Reports/Rechargehistory";
import Refundhotel from "./components/Reports/Refundhotel";
import Seller from "./components/Reports/Seller";
import Changecertificate from "./components/Customer Care/Changecertificate";
import Problemapproval from "./components/Customer Care/Problemapproval";
import Updatebanklogo from "./components/Update/Updatebanklogo";
import Updatebillerimage from "./components/Update/Updatebillerimage";
import Updatemargin from "./components/Update/Updatemargin";
import Updateproduct from "./components/Update/Updateproduct";
import Updatestatus from "./components/Update/Updatestatus";
import Updateuserdetail from "./components/Update/Updateuserdetail";
import Faq from "./components/FAQ/Faq";
import Productapprove from "./components/KYC Approve/Productapprove";
import Selleradhardetail from "./components/KYC Approve/Selleradhardetail";
import Sellerbankdetail from "./components/KYC Approve/Sellerbankdetail";
import Sellercontactdetail from "./components/KYC Approve/Sellercontactdetail";
import Sellerpandetail from "./components/KYC Approve/Sellerpandetail";
import Addoffer from "./components/Add/Addoffer";
import Addappbanner from "./components/Add/Addappbanner";
import Addnews from "./components/Add News/Addnews";
import Transcationquery from "./components/BBPS/Transcationquerry";
import Raisecomplaint from "./components/BBPS/Raisecomplaint";
import Complaintstatus from "./components/BBPS/Complaintstatus";
import Logout from "./components/Logout/Logout";


const App = () => {
  return (
    <Router>
      <div style={{ display: "flex" }}>
        {/* Sidebar */}
        <Sidebar />
        <div style={{ flex: 1 }}>
          {/* Header */}
          <Header title="BBPS Admin Panel" />

          {/* Main Content */}
          <div style={{ padding: "1rem" }}>
            <Routes>
              {/* Define each route with unique paths */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/odhwallet" element={<Odhwallet />} />{" "}
              {/* Odhwallet route */}
              <Route path="/odhmoney" element={<Odhmoney />} />
              <Route path="/Returnwallet" element={<Returnwallet />} />
              <Route path="/Withdrawl" element={<Withdrawal />} />
              <Route path="/Offlinerequest" element={<Offlinerequest />} />
              <Route path="/invoices/rechargeandbill" element={<Recharge />} />
              <Route path="/invoices/addmoney" element={<Addodh />} />
              <Route path="/invoices/addwallet" element={<Addwallet />} />
              <Route
                path="/product/createcategory"
                element={<Createcategory />}
              />
              <Route path="/product/addbanner" element={<Addbanner />} />
              <Route
                path="/product/addproducttemplate"
                element={<Addprodtemp />}
              />
              <Route path="/product/addsize" element={<Addsize />} />
              <Route path="/product/createbrand" element={<Createbrand />} />
              <Route
                path="/product/createcategory"
                element={<Createcategory />}
              />
              <Route
                path="/product/createdessubcategory"
                element={<Createdesub />}
              />
              <Route
                path="/product/createproduct"
                element={<Createproduct />}
              />
              <Route
                path="/product/createsubcategory"
                element={<Createsub />}
              />
              <Route path="/product/createunit" element={<Createunit />} />
              <Route path="/approval/kycapproval" element={<Kycapproval />} />
              <Route
                path="/report/activatemembertxn"
                element={<Activatemembertxn />}
              />
              <Route path="/report/addwallet" element={<Addwallet />} />
              <Route path="/report/balancesheet" element={<Balancesheet />} />
              <Route
                path="/report/beneficiarytranscation"
                element={<Beneficiary />}
              />
              <Route path="/report/customerlist" element={<Customerlist />} />
              <Route
                path="/report/failrechargehistory"
                element={<Failrechargehistory />}
              />
              <Route
                path="/report/hotelbookinglist"
                element={<Hotelbooking />}
              />
              <Route
                path="/report/interestonwallet"
                element={<Interestwallet />}
              />
              <Route path="/report/investmentlist" element={<Investment />} />
              <Route
                path="/report/membercredit/debit"
                element={<Membercredit />}
              />
              <Route
                path="/report/memberwiseincome"
                element={<Memberwiseincome />}
              />
              <Route
                path="/report/odhpaymoneymember"
                element={<Odhpaymoneymember />}
              />
              <Route path="/report/orderproduct" element={<Orderproduct />} />
              <Route
                path="/report/rechargehistory"
                element={<Rechargehistory />}
              />
              <Route
                path="/report/refundhotelcacellation"
                element={<Refundhotel />}
              />
              <Route path="/report/sellerlist" element={<Seller />} />
              <Route
                path="/customercare/changecertificate"
                element={<Changecertificate />}
              />
              <Route
                path="/customercare/problemapproval"
                element={<Problemapproval />}
              />
              <Route
                path="/update/updatebanklogo"
                element={<Updatebanklogo />}
              />
              <Route
                path="/update/updatebillerimage"
                element={<Updatebillerimage />}
              />
              <Route path="/update/updatemargin" element={<Updatemargin />} />
              <Route path="/update/updateproduct" element={<Updateproduct />} />
              <Route path="/update/updatestatus" element={<Updatestatus />} />
              <Route
                path="/update/updateuserdetail"
                element={<Updateuserdetail />}
              />
              <Route path="/faq" element={<Faq />} />
              <Route path="/kyc/productapprove" element={<Productapprove />} />
              <Route path="/kyc/adhardetail" element={<Selleradhardetail />} />
              <Route path="/kyc/bankdetail" element={<Sellerbankdetail />} />
              <Route
                path="/kyc/contactdetail"
                element={<Sellercontactdetail />}
              />
              <Route path="/kyc/pandetail" element={<Sellerpandetail />} />
              <Route path="/add/addoffer" element={<Addoffer />} />
              <Route path="/add/addappbanner" element={<Addappbanner />} />
              <Route path="/add/addnews" element={<Addnews />} />
              <Route
                path="/bbps/transcationquery"
                element={<Transcationquery />}
              />
              <Route path="/bbps/raisecomplaint" element={<Raisecomplaint />} />
              <Route
                path="/bbps/complaintstatus"
                element={<Complaintstatus />}
              />
              <Route path="/bbps/logout" element={<Logout />} />
              <Route path="/" element={<Login />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default App;
